import { CostAllocationPayerType } from 'types';
import { settlementTexts } from 'consts/text';

export const payerMapper = {
    [CostAllocationPayerType.FOUNDATION]: settlementTexts.children.balanceTargetTypes.anotherEntity,
    [CostAllocationPayerType.PARENT]:
        settlementTexts.children.balanceTargetTypes.parentOrLegalGuardian,
};
